"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EmojiPeopleIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222M14.83 14a3.001 3.001 0 0 1-5.66 0zM14 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></svg>`
}, props));
EmojiPeopleIcon.displayName = 'EmojiPeopleIcon';
var _default = exports.default = EmojiPeopleIcon;